import React from "react";
import AppFaq from "./appFaq";
export const AppFaq1 = () => {
  return (
    <>
      <AppFaq />
    </>
  );
};
